/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CoreConfigHistoryDto
 */
export interface CoreConfigHistoryDto {
    /**
     *
     * @type {number}
     * @memberof CoreConfigHistoryDto
     */
    coreConfigurationId?: number;
    /**
     *
     * @type {string}
     * @memberof CoreConfigHistoryDto
     */
    uniqueId?: string;
    /**
     *
     * @type {number}
     * @memberof CoreConfigHistoryDto
     */
    schemaVersion?: number;
    /**
     *
     * @type {string}
     * @memberof CoreConfigHistoryDto
     */
    type?: CoreConfigHistoryDtoTypeEnum;
    /**
     *
     * @type {Date}
     * @memberof CoreConfigHistoryDto
     */
    createdAt?: Date;
    /**
     *
     * @type {string}
     * @memberof CoreConfigHistoryDto
     */
    createdByUserName?: string;
    /**
     *
     * @type {string}
     * @memberof CoreConfigHistoryDto
     */
    reason?: string;
}

/**
 * @export
 */
export const CoreConfigHistoryDtoTypeEnum = {
    Shadow: "Shadow",
    Draft: "Draft",
    Published: "Published",
} as const;
export type CoreConfigHistoryDtoTypeEnum =
    (typeof CoreConfigHistoryDtoTypeEnum)[keyof typeof CoreConfigHistoryDtoTypeEnum];

/**
 * Check if a given object implements the CoreConfigHistoryDto interface.
 */
export function instanceOfCoreConfigHistoryDto(
    value: object,
): value is CoreConfigHistoryDto {
    return true;
}

export function CoreConfigHistoryDtoFromJSON(json: any): CoreConfigHistoryDto {
    return CoreConfigHistoryDtoFromJSONTyped(json, false);
}

export function CoreConfigHistoryDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): CoreConfigHistoryDto {
    if (json == null) {
        return json;
    }
    return {
        coreConfigurationId:
            json["coreConfigurationId"] == null
                ? undefined
                : json["coreConfigurationId"],
        uniqueId: json["uniqueId"] == null ? undefined : json["uniqueId"],
        schemaVersion:
            json["schemaVersion"] == null ? undefined : json["schemaVersion"],
        type: json["type"] == null ? undefined : json["type"],
        createdAt:
            json["createdAt"] == null ? undefined : new Date(json["createdAt"]),
        createdByUserName:
            json["createdByUserName"] == null
                ? undefined
                : json["createdByUserName"],
        reason: json["reason"] == null ? undefined : json["reason"],
    };
}

export function CoreConfigHistoryDtoToJSON(
    value?: CoreConfigHistoryDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        coreConfigurationId: value["coreConfigurationId"],
        uniqueId: value["uniqueId"],
        schemaVersion: value["schemaVersion"],
        type: value["type"],
        createdAt:
            value["createdAt"] == null
                ? undefined
                : value["createdAt"].toISOString(),
        createdByUserName: value["createdByUserName"],
        reason: value["reason"],
    };
}
